import type { ReactNode } from "react";
import type { User } from "../types";
import { Icon } from "./Icon";
import "../admin.css";

interface AdminShellProps {
  user: User;
  error: string;
  children: ReactNode;
  onSignOut: () => void;
  onDismissError: () => void;
}

export function AdminShell({ user, error, children, onSignOut, onDismissError }: AdminShellProps) {
  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <span className="admin-brand-mark"><Icon name="shield" /></span>
          <div><strong>FitTracker</strong><small>Business console</small></div>
        </div>
        <div className="admin-sidebar-copy">
          <p className="eyebrow">ADMINISTRATOR</p>
          <h2>Operate the platform, not a personal training account.</h2>
          <p>Business performance, customers, access controls, and product policy live here.</p>
        </div>
        <div className="admin-operator">
          <span>{(user.name || user.email).slice(0, 1).toUpperCase()}</span>
          <div><strong>{user.name || "Administrator"}</strong><small>{user.email}</small></div>
        </div>
        <button className="button admin-signout" type="button" onClick={onSignOut}>
          <Icon name="logout" /> Sign out
        </button>
      </aside>

      <main className="admin-main">
        {error ? (
          <div className="error-banner" role="alert">
            <span>{error}</span>
            <button className="icon-button" type="button" onClick={onDismissError} aria-label="Dismiss error">
              <Icon name="close" />
            </button>
          </div>
        ) : null}
        {children}
      </main>
    </div>
  );
}
